export default "__VITE_ASSET__eKmdJujjP5TwHbHhd1dH3w__"